import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>
      <h2>Home Page</h2>
      <Link to="/manager">Manager</Link>
      <br />
      <Link to="/login">Login</Link>
      <br />
      <Link to="/aptitudeTest">AptitudeTest</Link>
    </div>
  );
}

export default Home;
